import PropTypes from 'prop-types';

import { Complete, Incomplete, PartiallyComplete } from './icons';

const CompletionIcon = ({ completionStat: { completed = 0, total = 0 } }) => {
  switch (true) {
    case !completed:
      return <Incomplete className="text-light-700 pgn__icon" data-testid="completion-solid-icon" />;
    case completed === total:
      return <Complete className="text-success pgn__icon" data-testid="check-circle-icon" />;
    default:
      return <PartiallyComplete className="text-success pgn__icon" data-testid="dashed-circle-icon" />;
  }
};

CompletionIcon.propTypes = {
  completionStat: PropTypes.shape({
    completed: PropTypes.number,
    total: PropTypes.number,
  }).isRequired,
};

export default CompletionIcon;
